import routes from './routes';
import Router from "./components/router/Router";
import Providers from './Providers';
import Network from './hooks/useNetwork';
import { useEffect } from 'react';
import { env } from './var/env';
import favicon from './favicon';
import Updater from './updater';

function App() {
/*
  const { dev, prod } = favicon;
  useEffect(() => {
    document.getElementById("favicon").href = `data:image/x-icon;base64,${(env.REACT_APP_DEBUG != "true" ? prod : dev)}`
  }, []);
*/
  return (
    <Providers>
      <Network />
      <Router routes={routes} />
      <Updater />
    </Providers>
  )
}


export default App;
